module.exports = __webpack_public_path__ + "static/img/encrypt_error.6a220e79.png";